import { Autocomplete, TextField } from '@mui/material';
import React, { SyntheticEvent, useMemo } from 'react';
import { useCourts } from '../Aemter/hooks';
import { ICourt } from '../Interfaces/IAemter';
import { getAmtsgerichtLabel } from '../services/dialog.service';

interface CourtSearchProps {
  courtId: number | null;
  setCourt: (court: ICourt | null) => void;
}

export const CourtSearch: React.FC<CourtSearchProps> = ({
  courtId,
  setCourt,
}) => {
  const [open, setOpen] = React.useState(false);
  const { courts, isLoadingCourts } = useCourts();

  const selectedCourt = useMemo(
    () => courts?.find(court => court.idCourt === courtId) || null,
    [courts, courtId]
  );

  return (
    <Autocomplete<ICourt, false, false, false>
      fullWidth
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      value={selectedCourt}
      getOptionLabel={getAmtsgerichtLabel}
      options={courts || []}
      isOptionEqualToValue={(option, value) =>
        option.idCourt === (value?.idCourt ?? option.idCourt)
      }
      loading={isLoadingCourts}
      onChange={(_: SyntheticEvent, value: ICourt | null) => setCourt(value)}
      renderInput={params => (
        <TextField {...params} label='Amtsgericht' size='small' />
      )}
    />
  );
};
// import React, { SyntheticEvent, useState } from 'react';

// import { Autocomplete, CircularProgress, TextField } from '@mui/material';
// import { ICourt } from '../Interfaces/IAemter';
// import { useCourts } from '../Aemter/hooks';
// import { getAmtsgerichtLabel } from '../services/dialog.service';

// interface IProps {
//   courtId: number | null;
//   setCourt: Function;
// }

// export const CourtSearch: React.FC<IProps> = ({
//   courtId,
//   setCourt,
// }) => {
//   const [open, setOpen] = useState(false);
//   const { courts, isLoadingCourts } = useCourts();

//   function onChange(_event: SyntheticEvent, CourtObject: ICourt | null) {
//     setCourt(CourtObject);
//   }

//   return !isLoadingCourts && courts ? (
//     <Autocomplete
//       id='searchbar-districtCourt'
//       fullWidth
//       open={open}
//       onOpen={() => {
//         setOpen(true);
//       }}
//       onClose={() => {
//         setOpen(false);
//       }}
//       value={
//         courtId
//           ? courts.find(courtObject => courtObject.idCourt === courtId)
//           : null
//       }
//       getOptionLabel={option => getAmtsgerichtLabel(option)}
//       loadingText='Laden...'
//       options={courts}
//       isOptionEqualToValue={(option, value) =>
//         option.idPostcode === value.idPostcode
//       }
//       loading={isLoadingCourts}
//       onChange={onChange}
//       renderInput={params => (
//         <TextField
//           {...params}
//           label='Amtsgericht'
//           size='small'
//           InputProps={{
//             ...params.InputProps,
//             endAdornment: (
//               <React.Fragment>
//                 {isLoadingCourts ? (
//                   <CircularProgress color='inherit' size={20} />
//                 ) : null}
//                 {params.InputProps.endAdornment}
//               </React.Fragment>
//             ),
//           }}
//         />
//       )}
//     />
//   ) : null;
// };
